import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, FRONT_USER_ROLE_COOKIE_NAME } from '../../../auth/constants.js';
import MetaData from './MetaData';


class DisplaySent extends React.PureComponent {

  state = {
    concordDetail: null,  // metadata of 1 concordance
  }

  componentDidMount() {
    const data = {
      sent_id: this.props.sentId,
      collection: this.props.collection,
      lang: this.props.lang,
      aligned_language:this.props.alignedLang,
      login: (Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME))?
        Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME):"",
      role: (Cookies.get(FRONT_USER_ROLE_COOKIE_NAME))? 
        Cookies.get(FRONT_USER_ROLE_COOKIE_NAME):"",

    };

    const endpoint = '/get_result_meta.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((concordDetail) => {
          // Example of `concordDetail`:
          // {
          //   `metadata`,  // object, arbitrary key/value pairs
          //   `left_context`,  // str
          //   `sentence`,  // str
          //   `right_context`,  // str
          //   `svg`,  // str, syntax tree
          //   `tokens`,  // array of object like { id, cat, features, lemma, form }
          //   `relations`,  // array of object like { gouv, dep, rel }
          // }
          this.setState({ concordDetail });
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
  };
  handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.state.isOpen) {
      this.setState({kwicClass:"flex"});
    } else {
      this.setState({kwicClass:"flex-two-panels"});
    }
  };

  render() {
    const { concordDetail } = this.state;
    
    return (
 
      <div className="flex flex-between">
           <div className="flex">
            <div className="padding-1-rem">
              {concordDetail &&
                <MetaData sent_id={this.props.sentId} concordDetail={concordDetail} />
              }
            </div>
          </div>
      </div>
    );
  }
}

DisplaySent.propTypes = {
  sentId: PropTypes.string,
  collection: PropTypes.string,
  lang: PropTypes.string,
  alignedLang: PropTypes.string,
};

export default withTranslation()(DisplaySent);
